import { Box, Grid, Tooltip, Typography } from '@mui/material';
import React, { Fragment } from 'react';

interface DownLoadProps {
    toggleDrawer: () => void;
}

function DownloadAppComponent({toggleDrawer}:DownLoadProps) {
  return (
    <Fragment>
        <Box  sx={{ ml: 8 }} className="main-container"
            role="presentation"
            onClick={toggleDrawer}
            onKeyDown={toggleDrawer}
            onMouseLeave={toggleDrawer}
        >
            <Grid container className={"hideScrollbar"}  sx={{minHeight: "calc(100%-120px)",mt: 8}}>
                <Grid container>
                    <Grid item xs={12} sm={3}>                    
                        <img src='./appMainScreen.webp' />
                    </Grid>
                    <Grid item xs={12} sm={3}>       
                        <img src='./LoginScreen.webp' />                          
                    </Grid>
                    <Grid item xs={12} sm={3}>       
                        <img src='./mainScreen.webp' />                          
                    </Grid>
                    <Grid item xs={12} sm={3}>       
                        <img src='./mainScreen.webp' />                          
                    </Grid>
                </Grid>
                <Grid container sx={{mt: 15}}>
                    <Grid item xs={12} sm={6}>  
                        <Tooltip title="Donwload Androind App">
                            <a href='https://play.google.com/store/apps/details?id=com.ieqmax' target='_blank'>                  
                                <img src='./Play-Store.png' width={'84%'} />  
                            </a>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={12} sm={6}>       
                        <Tooltip title="Download Apple App">
                        <a href='https://apps.apple.com/us/app/ieqmax/id6443721688' target='_blank'>                            
                            <img src='./App-Store.png'  width={'84%'} />                           
                        </a>
                        </Tooltip>
                    </Grid> 
                </Grid>                                           
            </Grid>
    </Box>
    </Fragment>
  )
}

export default DownloadAppComponent
